module.exports = __webpack_public_path__ + "img/avatar-s-14.9ab8c514.png";